import React from 'react';
import { Link } from 'react-router-dom';
import './ServiceSection.css';
import 'animate.css';

function ServicesSection() {
  const services = [
    {
      title: 'Goshala',
      description: 'We care for 450 cows daily in our goshala & now it\'s your turn to help us care for cows. We request you to join us for support and feed.',
      link: '/services/goshala'
    },
    {
      title: 'Guest House',
      description: 'The guest house hosts both devotee and prospective devotee guests from around the globe. There are 22 luxurious marble rooms available.',
      link: '/services/guesthouse'
    },
    {
      title: 'ISKCON Altars',
      description: 'When the ISKCON temple at Ujjain was inaugurated in 2006, we decided to buy three very large-sized altars for our temple deities.',
      link: '/services/altars'
    },
    {
      title: 'Ayurvedic Clinic',
      description: 'Ayurveda has reached great heights in India due to its natural surroundings, deep-rooted science of healing, and the hard work of dedicated practitioners.',
      link: '/services/ayurvedic-clinic'
    },
    {
      title: 'Deities Dress',
      description: 'When we inaugurated our temple in Ujjain, we ordered 27 sets of dresses from Vrindavan, Mumbai, and Mayapur for our deities.',
      link: '/services/deities-dress'
    },
    {
      title: 'Govinda’s Restaurant',
      description: 'Experience the taste of pure vegetarian cuisine at ISKCON Govinda’s, offering a variety of delicious and sanctified food items.',
      link: '/services/govindas'
    }
  ];

  return (
    <section className="services">
      <div className="container">
        <h2 className="section-title">Our Services</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <div
              key={index}
              className={`service-card animate__animated animate__fadeInUp animate__delay-${index}s`}
            >
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <Link to={service.link} className="read-more-btn">Read More</Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
